import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExploreIcon from "@mui/icons-material/Explore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserDetails } from "../../../models/interfaces";
import { LightTooltip, theme } from "../../../utils/styles";
import compatibilityComponentsStyles from "./compatibilityComponents.styles";

interface CustomProps {
  targetDetails: UserDetails;
  userDetails: UserDetails;
}

const TwoUsersDetails = (props: CustomProps) => {
  const classes = compatibilityComponentsStyles;
  const { t } = useTranslation();

  const UserCard = ({ details }: { details: UserDetails }) => {
    const [birthDate, birthTime] = (details.birth_date || "").split(" ");

    return (
      <Box sx={classes.userCard}>
        <Box sx={classes.userHeader}>
          <Box sx={classes.avatar}>
            <PersonIcon
              sx={{
                fontSize: 40,
                color: "#ffffff",
                [theme.breakpoints.down("sm")]: {
                  fontSize: 20,
                },
              }}
            />
          </Box>
          <Box>
            <LightTooltip
              title={details.nickname}
              placement="top"
              sx={{
                "& .MuiTooltip-tooltip": {
                  backgroundColor: "#ffffff",
                  fontSize: "20px",
                  color: "#000000",
                },
              }}
            >
              <Typography sx={classes.userName}>{details.nickname}</Typography>
            </LightTooltip>
            <Typography
              sx={details.nickname ? classes.nickname : classes.userName}
            >
              {details.name}
            </Typography>
          </Box>
        </Box>

        <Box sx={classes.detailsContainer}>
          <Box sx={classes.detailRow}>
            <CalendarTodayIcon sx={classes.icon} />
            <Box>
              <Typography sx={classes.label}>{t("birthDate")}</Typography>
              <Typography sx={classes.value}>{birthDate}</Typography>
            </Box>
          </Box>

          <Box sx={classes.detailRow}>
            <AccessTimeIcon sx={classes.icon} />
            <Box>
              <Typography sx={classes.label}>{t("birthTime")}</Typography>
              <Typography sx={classes.value}>{birthTime}</Typography>
            </Box>
          </Box>

          <Box sx={classes.detailRow}>
            <LocationOnIcon sx={classes.icon} />
            <Box>
              <Typography sx={classes.label}>{t("birthPlace")}</Typography>
              <Typography sx={classes.value}>{details.birth_place}</Typography>
            </Box>
          </Box>

          <Box sx={classes.detailRow}>
            <ExploreIcon sx={classes.icon} />
            <Box>
              <Typography sx={classes.label}>{t("coordinates")}</Typography>
              <Typography sx={classes.value}>
                {details.latitude}°, {details.longitude}°
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Grid container spacing={3} mb={3}>
      <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
        <UserCard details={props.userDetails} />
      </Grid>
      <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
        <UserCard details={props.targetDetails} />
      </Grid>
    </Grid>
  );
};

export default TwoUsersDetails;
